import RewardBadge from '@/components/Icon/CustomIcons/RewardBadge.svg'
import Text from '../Text'
import { ProgramRewardsByCategory } from '@/types/programs-new/programs-new'
import { getMinMaxRangeString } from './program-rewards-utils'

export default function ProgramRewardsList({
  rewardsByCategory: {
    enrollment,
    application,
    referral,
    participation,
    offPeakCharging,
    endOfProgram,
  },
}: {
  rewardsByCategory: ProgramRewardsByCategory
}) {
  return (
    <section>
      <div className="flex flex-col gap-2">
        {enrollment && (
          <RewardListItem
            title={`Enrollment`}
            content={`$${getMinMaxRangeString(enrollment)} per device`}
          />
        )}
        {application && (
          <RewardListItem
            title={`Application`}
            content={`$${getMinMaxRangeString(application)} per device`}
          />
        )}
        {participation && (
          <RewardListItem
            title={`Participation`}
            content={`$${getMinMaxRangeString(participation)} per device/year`}
          />
        )}
        {referral && (
          <RewardListItem
            title={`Referral`}
            content={`$${getMinMaxRangeString(referral)} per referral`}
          />
        )}
        {offPeakCharging && (
          <RewardListItem
            title={`Off-Peak Charging`}
            content={`$${getMinMaxRangeString(offPeakCharging)} per kWh`}
          />
        )}
        {endOfProgram && (
          <RewardListItem
            title={`End of Program`}
            content={`$${getMinMaxRangeString(endOfProgram)} per device`}
          />
        )}
      </div>
    </section>
  )
}

export function RewardListItem({
  content,
  title,
}: {
  content: string
  title: string
}) {
  return (
    <div className="flex flex-row gap-2 items-center">
      <img
        src={RewardBadge}
        className="size-6 rounded-full fill-base-success bg-base-green-100"
      />
      <Text variant="body2" className="!text-xs">
        {title}:{' '}
      </Text>
      <Text variant="body2" className="!font-bold text-base-green-900 !text-xs">
        {content}
      </Text>
    </div>
  )
}
